// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import 'normalize.css/normalize.css';
import 'element-ui/lib/theme-default/index.css';    // 默认主题

import AMap from 'vue-amap';
import store from './views/store';
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale/lang/zh-CN';
import func from './utils/function';
import {sdkRelease} from './utils/encoder'
import invoicePdf from './utils/invoicepdf';

Vue.use(VueI18n);
Vue.use(ElementUI, { locale });
Vue.use(AMap);
Vue.use(func);
Vue.use(invoicePdf);

const i18n = new VueI18n({
  messages: {
      'i18n': require('../static/i18n/i18n.json'),
  }
});

AMap.initAMapApiLoader({
  // 高德的key
  key: 'af8f94f977f1a15f03ee2984bb124398',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView',
      'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation', 'Geocoder']
});


router.beforeEach((to, from, next) => {
  const token = store.state.token;
  NProgress.start();
  if (to.path == '/' || to.path == '/login'|| to.path == '/factory') {
    sdkRelease();
    next()
  } else {
    if (token != 'null' && token != null && token != "") {
      // Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      next() // 如果有token就正常转向
    } else {
      next('/') // 否则跳转回登录页
      sdkRelease();
    }
  }
  next();
});

router.afterEach(transition => {
  NProgress.done();
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js